// This is used to disregard current timezone and always treat the calendar as if it's in UTC
import * as moment from 'moment';

export const normalizeDate = (date: moment.Moment): moment.Moment => {
	const offset = date.utcOffset();
	const date2 = date.utc();

	date2.add(offset, 'minutes');
	return date2;
};

export const isDateAfterToday = (date: moment.Moment): boolean => {
	const now = moment().utc().startOf('day');
	return date.isAfter(now);
};
